module.exports = __webpack_public_path__ + "static/media/corporate-services-img10.9c18687f.jpg";